import { render, staticRenderFns } from "./msnyDetail.vue?vue&type=template&id=47c43f10&scoped=true&"
import script from "./msnyDetail.vue?vue&type=script&lang=js&"
export * from "./msnyDetail.vue?vue&type=script&lang=js&"
import style0 from "./msnyDetail.vue?vue&type=style&index=0&id=47c43f10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c43f10",
  null
  
)

export default component.exports